import(/* webpackMode: "eager" */ "/vercel/path0/src/app/try/gojuon/write/page.tsx");
